var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lock_svg__a)",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.875 11.375H6.125a1.75 1.75 0 0 0-1.75 1.75v12.25c0 .966.784 1.75 1.75 1.75h15.75a1.75 1.75 0 0 0 1.75-1.75v-12.25a1.75 1.75 0 0 0-1.75-1.75Z",
    fill: "#FFE1CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 11.375V7a6.125 6.125 0 1 1 12.25 0v4.375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 21.875a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lock_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};

export default SvgLock;